<template>
  <div class="customer-sidebar border-right bg-white d-flex flex-column" style="width: 310px; min-width: 270px;">
    <!-- Buscador y Filtros -->
    <div class="pa-2 border-bottom flex-grow-0">
      <s-text
        v-model="search"
        placeholder="Buscar cliente..."
        dense
        hide-details
        prepend-inner-icon="mdi-magnify"
        clearable
      />

      <!-- Filtro rápido por estado de avance -->
      <!-- <div class="d-flex align-center gap-1 mt-2 flex-wrap">
        <v-chip
          x-small
          filter
          :input-value="statusFilter === 'all'"
          @click="statusFilter = 'all'"
          class="font-weight-medium"
        >
          Todos ({{ customerCards.length }})
        </v-chip>
        <v-chip
          x-small
          filter
          color="grey lighten-3"
          :input-value="statusFilter === 'unprogrammed'"
          @click="statusFilter = 'unprogrammed'"
          class="font-weight-medium"
        >
          Sin prog. ({{ countByStatus('unprogrammed') }})
        </v-chip>
        <v-chip
          x-small
          filter
          color="blue lighten-5"
          text-color="blue darken-4"
          :input-value="statusFilter === 'partial'"
          @click="statusFilter = 'partial'"
          class="font-weight-medium"
        >
          Parcial ({{ countByStatus('partial') }})
        </v-chip>
        <v-chip
          x-small
          filter
          color="green lighten-5"
          text-color="green darken-4"
          :input-value="statusFilter === 'complete'"
          @click="statusFilter = 'complete'"
          class="font-weight-medium"
        >
          Listo ({{ countByStatus('complete') }})
        </v-chip>
        <v-chip
          x-small
          filter
          color="red lighten-5"
          text-color="red darken-4"
          :input-value="statusFilter === 'over'"
          @click="statusFilter = 'over'"
          class="font-weight-medium"
        >
          Sobre ({{ countByStatus('over') }})
        </v-chip>
      </div> -->
    </div>

    <!-- Lista con Scroll Independiente de Clientes -->
    <div class="flex-grow-1 overflow-y-auto pa-2">
      <div v-if="filteredList.length === 0" class="text-center py-6 grey--text caption">
        No se encontraron clientes con el filtro aplicado.
      </div>

      <div
        v-for="c in filteredList"
        :key="c.customerId || c.customerName"
        class="customer-item pa-2 mb-2 rounded-lg cursor-pointer"
        :class="{ 'customer-item-active': selectedCustomerId === (c.customerId || c.customerName) }"
        @click="$emit('select-customer', c)"
      >
        <div class="d-flex align-center justify-space-between mb-1">
          <span class="font-weight-bold text-caption text-truncate grey--text text--darken-4" style="max-width: 180px;" :title="c.customerName">
            {{ c.customerName }}
          </span>
          <v-chip x-small :color="c.statusBadgeColor" :text-color="c.statusTextColor" class="font-weight-bold" style="height: 18px; font-size: 10px;">
            {{ c.statusLabel }}
          </v-chip>
        </div>

        <div class="d-flex justify-space-between text-caption grey--text text--darken-2" style="font-size: 11px;">
          <span :title="'Ppto Directo: ' + formatNumber(c.directBudgetTons, 1) + (c.allocatedFromBagTons > 0 ? ' | Bolsa: +' + formatNumber(c.allocatedFromBagTons, 1) : '')">
            Base: <strong>{{ formatNumber(c.availableBaseTons || c.budgetTons, 1) }}</strong>
          </span>
          <span v-if="c.otherProgrammedTons > 0" class="orange--text text--darken-3 font-weight-medium" :title="'Otras programaciones: ' + formatNumber(c.otherProgrammedTons, 1) + ' TM'">
            Otras: {{ formatNumber(c.otherProgrammedTons, 1) }}
          </span>
          <span class="primary--text font-weight-bold">Prog: {{ formatNumber(c.programmedTons, 1) }}</span>
          <span :class="c.operatingBalanceTons < 0 ? 'red--text font-weight-bold' : (c.allocatedFromBagTons > 0 ? 'deep-purple--text text--darken-3 font-weight-bold' : '')">
            Saldo: <strong>{{ formatNumber(c.operatingBalanceTons !== undefined ? c.operatingBalanceTons : c.balanceTons, 1) }} TM</strong>
          </span>
        </div>

        <!-- Barra de Progreso Compacta -->
        <v-progress-linear
          :value="c.progressPercent"
          :color="c.progressBarColor"
          height="4"
          rounded
          class="mt-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "../utils/CommercialProgrammingCalculations";

export default {
  name: "CommercialClientList",
  props: {
    customerCards: {
      type: Array,
      required: true,
    },
    selectedCustomerId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      search: "",
      statusFilter: "all",
    };
  },
  computed: {
    filteredList() {
      let list = this.customerCards;

      if (this.search && this.search.trim()) {
        const term = this.search.trim().toLowerCase();
        list = list.filter(
          (c) => (c.customerName || "").toLowerCase().includes(term) || String(c.customerId || "").includes(term)
        );
      }

      if (this.statusFilter !== "all") {
        list = list.filter((c) => c.statusKey === this.statusFilter);
      }

      return list;
    },
  },
  methods: {
    formatNumber,
    countByStatus(status) {
      return this.customerCards.filter((c) => c.statusKey === status).length;
    },
  },
};
</script>

<style scoped>
.border-right {
  border-right: 1px solid #e2e8f0 !important;
}
.border-bottom {
  border-bottom: 1px solid #e2e8f0 !important;
}
.gap-1 {
  gap: 4px;
}
.cursor-pointer {
  cursor: pointer;
}
.customer-item {
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  background-color: #ffffff;
}
.customer-item:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}
.customer-item-active {
  background-color: #eff6ff !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.15);
}
</style>
